import { Stack } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { Title } from './Title';

interface ICompassHeader {
  lastUpdateDate?: Date;
  title?: string;
}

export const CompassHeader = ({ lastUpdateDate, title }: ICompassHeader) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction={isDesktop ? 'row' : 'column'}
      alignItems='flex-start'
      justifyContent={'space-between'}
      flexWrap={'wrap'}
    >
      <Title title={title} />
    </Stack>
  );
};
